import { render, staticRenderFns } from "./FormFields.vue?vue&type=template&id=89c9aa22&"
import script from "./FormFields.vue?vue&type=script&lang=js&"
export * from "./FormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports